import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=0e3625b0&scoped=true&"
import script from "./restaurant.vue?vue&type=script&lang=js&"
export * from "./restaurant.vue?vue&type=script&lang=js&"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=0e3625b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3625b0",
  null
  
)

export default component.exports